import { ParamListBase, RouteProp } from '@react-navigation/native';
import {
  NativeStackHeaderProps,
  NativeStackNavigationOptions,
} from '@react-navigation/native-stack';
import { ReactNode } from 'react';

export function getRewardsScreenOptions(
  { route }: { route: RouteProp<ParamListBase, string> },
  headerComponent: (props: NativeStackHeaderProps) => ReactNode
): NativeStackNavigationOptions {
  const isModalRoute =
    route.params &&
    'screen' in route.params &&
    ['history', 'birthday'].includes(route.params.screen as string);

  return isModalRoute
    ? {
        header: headerComponent,
        presentation: 'containedTransparentModal',
        contentStyle: { backgroundColor: 'transparent' },
        animation: 'slide_from_bottom',
      }
    : {
        presentation: 'card',
        header: headerComponent,
      };
}
